module.exports = new __parcel__URL__("shop_machines_mvhq.833a7b33.png").toString();